import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import heroImage from '../images/patna.png';
import { centers } from '../data/siteContent';



const OurCenters = () => {
  return (
    <div className="our-centers-page">
      <TopBar />
      <Navbar />

      <section className="hero-section">
        <div className="hero-image">
          {/* <img src={heroImage} alt="Our centers" /> */}
        </div>
        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Our Centers</h1>
            <p>बिहार और आसपास के क्षेत्रों में परामर्श सहायता</p>
          </motion.div>
        </div>
      </section>

      <section className="centers-section">
        <div className="container">
          <div className="centers-heading">
            <span className="section-kicker">Connected locations</span>
            <h2 className="section-title">Consultation Network</h2>
            <p className="centers-disclaimer">
              Verified city locations are listed below. Where the exact consultation point is not published in
              the project material, the appointment team shares the detailed address directly during booking.
            </p>
          </div>

          <motion.div
            className="centers-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            {centers.map((center, index) => (
              <motion.div
                key={center.id}
                className="center-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                whileHover={{ scale: 1.02 }}
              >
                {/* <Link to={`/center/${center.id}`} className="center-link"> */}
                  <div className="center-image" style={{display:'flex', justifyContent:'center', alignItems:'center' }} >
                    <p style={{fontSize:'24px', fontWeight:'600', color:'red' }}>{center.city}</p>
                   
                  </div>
                  <div className="center-info">
                    <h3>{center.name}</h3>
                    <p><i className="fas fa-location-dot"></i> {center.address}</p>
                    <p><i className="fas fa-phone-alt"></i> {center.phone}</p>
                    {/* <small className="center-note">{center.note}</small> */}
                  </div>
               {/*  </Link> */}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurCenters;
